import * as styles from './RoiCalculator.module.scss';

export const calculatorTypes = {
  default: {
    users: {
      type: 'number',
      original: 1000000,
      multiples: [1, 1.25, 1.5, 1.75, 2],
      label: 'User Sessions',
      color: styles.emerald,
    },
    cvr: {
      type: 'percentage',
      original: '10.0',
      multiples: [1, 1.1, 1.2, 1.3, 1.4],
      label: 'Conversion Rate',
      color: styles.emerald,
    },
    orderValue: {
      type: 'currency',
      original: '30.00',
      multiples: [1, 1.1, 1.2, 1.3, 1.4],
      label: 'Average Order Value',
      color: styles.emerald,
    },
    affectedUsers: {
      type: 'percentage',
      original: '8.0',
      multiples: [0.4, 0.6, 0.75, 0.9, 1],
      label: '"Bad" Sessions',
      color: styles.pinkDeep,
    },
    conversionImpact: {
      type: 'percentage',
      original: '30.0',
      multiples: [0.6, 0.7, 0.8, 0.9, 1],
      label: 'Conversion Impact',
      color: styles.pinkDeep,
    },
  },
  'grow revenue': {
    monthlySessions: {
      type: 'number',
      original: 1000000,
      multiples: [1, 1.25, 1.5, 1.75, 2],
      label: 'Monthly Sessions',
      color: styles.emerald,
    },
    cvr: {
      type: 'percentage',
      original: '5.0',
      multiples: [1, 1.1, 1.2, 1.3, 1.4],
      label: 'Conversion Rate',
      color: styles.emerald,
    },
    orderValue: {
      type: 'currency',
      original: '100.00',
      multiples: [1, 1.1, 1.2, 1.3, 1.4],
      label: 'Average Order Value',
      color: styles.emerald,
    },
    repeatCustomers: {
      type: 'percentage',
      original: '30.0',
      multiples: [1, 1.1, 1.2, 1.3, 1.4],
      label: 'Repeat Customers',
      color: styles.emerald,
    },
    grossMargin: {
      type: 'percentage',
      original: '30.0',
      multiples: [1, 1.1, 1.2, 1.3, 1.4],
      label: 'Gross Margin',
      color: styles.emerald,
    },
  },
};
